const BASE_URL = 'https://baobab-backend.baobabchallenge.com/api';
const BASE_IMAGE_URL = 'https://baobab-backend.baobabchallenge.com/images';

export default {
  // API Endpoints
  getJuries: `${BASE_URL}/getJuries`,
  getCandidates: `${BASE_URL}/getCandidates`,
  getCriterias: `${BASE_URL}/getCriterias`,
  getCriteriasByCategory: `${BASE_URL}/getCriteriasByCategory`,
  getEvaluations: `${BASE_URL}/getEvaluations`,
  submitEvaluation: `${BASE_URL}/submitEvaluation`,
  getCandidateRatingsByJury: `${BASE_URL}/getCandidateRatingsByJury`,
  getGeneralResults: `${BASE_URL}/getGeneralResults`,
  getWinner: `${BASE_URL}/getWinner`,
  getEvaluationByJury: (id) => `${BASE_URL}/getEvaluationByJury/${id}`,
  getEvaluationByCandidate: (id) => `${BASE_URL}/getEvaluationByCandidate/${id}`,
  getEvaluationByCriteria: (id) => `${BASE_URL}/getEvaluationByCriteria/${id}`,

  // Image URL Utility Functions
  getJuryImageUrl: (filename) => `${BASE_IMAGE_URL}/juries/${filename}`,
  getCandidateImageUrl: (filename) => `${BASE_IMAGE_URL}/candidates/${filename}`
};
